<template>
     <div class="address mt-4">
        <div :class="{
                'input-focus-effect': true,
                'rv-valiadate-input-form': error
            }">
            <input :class="address != '' ? 'border-primary' : ''" type="text" id="inputAddress"
                v-model="address" @focus="$emit('update:error', '')"/>
            <label :class="{
                    'mb-0': true,
                    'input-on-alue': address != ''
                }">Địa chỉ</label>
        </div>
        <div class="text-danger fs-12px mt-1" v-if="error">{{error}}</div>
    </div>
</template>
<script>
export default {
    props: ['data', 'error'],
    data() {
        return {
            address: ''
        }
    },
    watch: {
        data(val){
            this.address = val;
        },
        address(val){
            this.$emit('update:data', val);
        }
    },
    created() {
        this.address = this.data;
    }
}
</script>
